import APIV5 from '~/models/api';
import Link from '~/scripts/services/model/link';
import Relations from '~/scripts/services/relations';

export default class QueryClassesController {
	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {import('angular').IScope} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('~/scripts/services/model/node-service').NodeService} NodeService
	 * @param {*} Notification
	 */
	constructor(
		$injector,
		$scope,
		$timeout,
		$translate,
		NodeService,
		Notification,
	) {
		this.$injector = $injector;
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.$translate = $translate;
		this.NodeService = NodeService;
		this.Notification = Notification;

		/** @type {any[]} */
		this.children = [];

		/** @type {any[]} */
		this.classes = [];

		/** @type {any[]} */
		this.classDico = [];

		this.data = undefined;
		this.disabled = undefined;

		/** @type {?import('../query-editor/query-editor.controller').default} */
		this.editor = null;

		this.isLeaf = true;

		/** @type {?import('angular').INgModelController} */
		this.ngModelCtrl = null;

		/**
		 * @type {{displayTarget: boolean}}
		 */
		this.options = {
			displayTarget: false,
		};

		/** @type {string} */
		this.tabActive = 'definedby';

		/**
		 * @type {?{
		 *   linker_kid: import('@knitiv/api-client-javascript').LinkerKNode,
		 *   class_kid: import('@knitiv/api-client-javascript').KNode,
		 *   relation_kid: import('@knitiv/api-client-javascript').KRelationV4,
		 * }}
		 */
		this.targetModel = null;

		/** @type {any} */
		this.tmp = {
			targetModel: null,
		};
	}

	/**
	 * @param {any} object
	 */
	async addFrom(object) {
		let isFromExist = false;

		for (const from of this.classes) {
			if (from !== undefined && from.node === object.kid) {
				isFromExist = true;
			}
		}

		if (isFromExist) {
			this.Notification.warning({
				title:   this.$translate.instant('error.title'),
				message: 'Cette classe a déjà été sélectionnée',
			});
		}
		else if (object && object.kid) {
			this.classes.length = 0;
			const data = await APIV5.instance.objectInfo({ kid: object.kid }, { id: 'query-classes.add-from' });
			this.classes.push({
				node:              object.kid,
				name:              object.name,
				type:              object.type || object.type_kid,
				inherits_extended: !data.error && data.parent_inherits.nb > 0 ? 0 : -1,
			});
			this.$timeout(() => {
				if (this.editor?.queryEditorForm) {
					this.editor.queryEditorForm.$setDirty();
				}
			});
		}
	}

	async initTreeTabs() {
		const result = await APIV5.instance.queryChildren(
			{ node_kid: this.classes[0].node },
			{ id: 'query-classes.init-tree-tabs' },
		);
		const path = [
			{
				kid: 'PATH_REL',
			},
		];
		return this.$timeout(() => {
			this.isLeaf = result.is_leaf;
			this.children = result.result.map(child => ({
				node:       child.kid,
				name:       child.name,
				linker_kid: child.linker?.kid ?? '0',
				// @ts-ignore
				linker_info:       child.linker?.kid === '0' ? undefined : {
					name: child.linker?.name,
				},
				path:              [
					...path,
					{
						kid:        child.kid,
						flow:       'down',
						linker_kid: child.linker?.kid ?? '0',
						// @ts-ignore
						linker_info: child.linker?.kid === '0' ? undefined : {
							name: child.linker?.name,
						},
						name:        child.name,
						type:        child.type_kid,
					},
				],
				type:              child.type_kid,
				inherits_extended: 0,
			}));
		});
	}

	async loadClassDico() {
		if (this.options.displayTarget) {
			const relations = await Relations.get(this.$injector);
			const data = await APIV5.instance.objectInfo({ kid: this.classes[0].node }, { id: 'query-classes.on-init' });

			if (data?.kndef.CLASS.DICO) {
				this.classDico = Object.values(data.kndef.CLASS.DICO)
					.map(dicoItem => {
						const link = new Link(dicoItem);
						let name = link.getName();
						const relation = relations.find(r => r.kid === link.relation_kid);
						if (relation) {
							name = `${relation.getName()} ${name}`;
						}
						link.name = name;
						return link;
					});
			}
		}
	}

	updateTargetModel() {
		const r = /^(?<relation_kid>K_NODE;.+)\|(?<class_kid>K_NODE;.+)::(?<linker_kid>0|K_NODE;.+)$/
			.exec(this.tmp.targetModel);
		// @ts-ignore
		this.targetModel = r?.groups ?? null;
	}

	$onInit() {
		this.$scope.$watch('$ctrl.classes', (newClasses, oldclasses) => {
			this.ngModelCtrl?.$validate();
			if (newClasses?.length > 0 && (oldclasses.length === 0 || newClasses[0].node !== oldclasses[0].node)) {
				(async () => {
					await this.initTreeTabs();
					await this.loadClassDico();
				})();
			}
			return true;
		}, true);

		if (this.classes?.length > 0) {
			(async () => {
				await this.initTreeTabs();
				await this.loadClassDico();
			})();
		}

		this.$scope.$watch('$ctrl.targetModel', () => {
			if (this.targetModel) {
				const link = new Link({
					linker_kid:   this.targetModel.linker_kid ?? '0',
					objnum2_kid:  this.targetModel.class_kid,
					relation_kid: this.targetModel.relation_kid,
				});
				this.tmp.targetModel = link.getId();
			}
			else {
				this.tmp.targetModel = undefined;
			}
		});
	}
}
